module.exports = __webpack_public_path__ + "img/landos-mark__list.png?9d4c191ca36311405374ddb2de526968";